import { Injectable } from '@angular/core';
import { HttpService } from '../../../../../shared/services/http/http-client.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class ModalUploadNfService {
  protected urlBase = environment.url_server;

  constructor(private http: HttpClient) { }

  registerNfFile(body: any, params: any) {

   return this.http.post(this.urlBase + '/files/invoice', body, {params: params});

  }
}
